import { Description, Discount, Email, Group, Moped, NotificationAdd, QuestionAnswer, Settings, ViewCarousel, Warehouse, Badge } from "@mui/icons-material";
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom"
const drawerWidth = 240;

export default function AdminDrawer({ openDrawer, toggleDrawer }) {
    const { t } = useTranslation();
    const lessThanSmall = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    const location = useLocation();
    const LIST_ITEMS = [
        {
            title: "Users",
            href: "/admin",
            icon: Group,
        },
        {
            title: "Drivers",
            href: "/admin/drivers",
            icon: Moped,
        },
        {
            title: "Service points employees",
            href: "/admin/employees",
            icon: Badge,
        },
        {
            title: "Orders",
            href: "/admin/orders",
            icon: Description,
        },
        {
            title: "Service points",
            href: "/admin/service_points",
            icon: Warehouse,
        },
        {
            title: "Slider",
            href: "/admin/slider",
            icon: ViewCarousel,
        },
        {
            title: "Subscribers",
            href: "/admin/subscribers",
            icon: Email,
        },
        {
            title: "Frequently asked questions",
            href: "/admin/faq",
            icon: QuestionAnswer,
        },
        {
            title: "Notifications",
            href: "/admin/notifications",
            icon: NotificationAdd,
        },
        {
            title: "Promo codes",
            href: "/admin/promos",
            icon: Discount,
        },
        {
            title: "Settings",
            href: "/admin/settings",
            icon: Settings,
        },
    ]
    return (
        <Drawer
            open={openDrawer}
            onClose={toggleDrawer}
            variant={lessThanSmall ? "temporary" : "permanent"}
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
        >
            <Toolbar />
            <Box sx={{ overflow: 'auto' }}>
                <List>
                    {LIST_ITEMS.map((item) => (
                        <ListItem key={item?.title} component={Link} to={item?.href} disablePadding>
                            <ListItemButton selected={location.pathname === item?.href}>
                                <ListItemIcon>
                                    <item.icon sx={{ color: "primary.main" }} />
                                </ListItemIcon>
                                <ListItemText sx={{ color: "black" }} primary={t(item?.title)} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Drawer>
    )
}